import React from 'react';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/billing/components/Billing/Footnote.styled';
import Text from 'app/components/layout/Text.styled';

const Footnote = () => (
  <Text data-t="billing-footnote-text" as={S.Footnote} size="m" type="semibold">
    <FormattedMessage id="billing_footnote" />
  </Text>
);

export default Footnote;
